import targetActionTypes from './TargetFieldsConstants';
import mappingActionTypes from '../mapping/MappingConstants';

const initialStore = {
  fields: [],
  tempDivisionFields: [],
  backupFields: [],
  schemas: [],
  fetchingTargetFields: false,
  requiredFields: []
};

const setTargetFieldDisabledValue = (targetFields, name, value) => {
  let targetField = targetFields.find(e => e.name == name);
  let foundedDependantField;
  if (targetField !== undefined) { targetField.disabled = value; }
  if (targetField !== undefined && targetField.dependent !== undefined && [...targetField.dependent].length !== 0) {
    targetField.dependent.forEach(dependentField => {
      foundedDependantField = targetFields.find(e => e.name == dependentField);
      foundedDependantField.disabled = value;
    });
  }
  return [...targetFields];
};

const markTargetFieldAsMapped = (targetField, prevValue, targetFields) => {
  setTargetFieldDisabledValue(targetFields, prevValue, false);
  setTargetFieldDisabledValue(targetFields, targetField, true);
  return [...targetFields];
};

const disableMarkedFields = (fields, mappedFields) => {
  let newFields = [...fields];
  fields.map(field => {
    if (mappedFields.find(mappedField => mappedField.targetField === field.name)) {
      setTargetFieldDisabledValue(newFields, field.name, true);
    }
  });
  return [...newFields];
};

const enableMarkedFields = (fields, mappedFields) => { 
  let newFields = [...fields];
  fields.map(field => {
    if (mappedFields.find(mappedField => mappedField.targetField === field.name)) {
      setTargetFieldDisabledValue(newFields, field.name, false);
    }
  });
  return [...newFields];
};

const TargetFieldsReducer = (state = initialStore, action) => {
  switch (action.type) {
    case targetActionTypes.FETCH_TARGET_MAPPING_INFORMATION_SUCCESS:
      return {
        ...state,
        fetchingTargetFields: false,
        fields: action.targetFields.map(target => ({ ...target, disabled: false, required: target.validations.required })),
        tempDivisionFields: action.targetFields.map(target => ({ ...target, disabled: false, required: target.validations.required })),
        requiredFields: action.targetFields.filter(target => (target.validations.required === true))
      };
    case mappingActionTypes.SET_MAPPED_FIELD: // eslint-disable-line no-case-declarations
      const { targetField, prevValue } = action;
      return {
        ...state,
        tempDivisionFields: markTargetFieldAsMapped(
          targetField, 
          prevValue, 
          [...state.tempDivisionFields.map( e => ({...e, dependent: [...e.dependent] }))]
        )
      };
    case mappingActionTypes.RESET_IMPORT_MAPPING_DATA_SUCCESS:
      return {
        ...state,
        fields: [ ...state.fields.map(field => ({ ...field, disabled: false })) ],
        tempDivisionFields: [ ...state.fields.map(field => ({ ...field, disabled: false })) ],
        backupFields: [ ...state.backupFields.map(field => ({ ...field, disabled: false })) ]
      };
    case targetActionTypes.BACKUP_TARGET_FIELDS:
      return { ...state, backupFields: state.fields.map(e => ({ ...e }))};
    case targetActionTypes.RESTORE_TARGET_FIELDS:
      return {
        ...state,
        fields: state.backupFields.map(e => ({ ...e })),
        tempDivisionFields: state.backupFields.map(e => ({ ...e }))
      };
    case targetActionTypes.FETCH_TARGET_FIELDS_SCHEMAS_SUCCESS:
      return { ...state, schemas: action.schemas };
    case targetActionTypes.FETCHING_TARGET_FIELDS:
      return { ...state, fetchingTargetFields: true };
    case targetActionTypes.DISABLE_MAPPED_TARGET_FIELDS:
      return {
        ...state,
        fields: disableMarkedFields([...state.fields.map( e => ({...e, dependent: [...e.dependent] }))], action.mappedFields),
        tempDivisionFields: disableMarkedFields([...state.fields.map( e => ({...e, dependent: [...e.dependent] }))], action.mappedFields),
        backupFields: disableMarkedFields([...state.backupFields.map( e => ({...e, dependent: [...e.dependent] }))], action.mappedFields)
      };
    case mappingActionTypes.ADD_DIVISION_MAP_TO_MAPPING:
      return { ...state, fields: [ ...state.tempDivisionFields.map(e => ({ ...e }))] };
    case mappingActionTypes.LOADED_MAPPED_FIELDS_DIVISION:
      return { ...state, tempDivisionFields: [ ...state.fields.map(e => ({ ...e }))] };
    case targetActionTypes.ENABLE_MAPPED_TARGET_FIELDS:
      return {
        ...state,
        tempDivisionFields: enableMarkedFields([...state.fields.map( e => ({...e, dependent: [...e.dependent] }))], action.mappedFields)
      };
    default:
      return { ...state };
  }
};

export default TargetFieldsReducer;



// WEBPACK FOOTER //
// ./src/redux/targetFields/TargetFieldsReducer.js